// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.truncate {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
}

.product-cell {
  max-width: 135px;
}

.name-cell {
  max-width: 90px;
}

.email-cell {
  max-width: 150px;
}

.address-cell {
  max-width: 155px;
}

.export-button mat-spinner {
  --mdc-circular-progress-active-indicator-color: currentColor;
}

.filter-wrapper {
  position: relative;
}

.filter-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--primary-color);
}

.filter-dropdown {
  position: absolute;
  z-index: 5;
  inset-inline-end: 0;
  top: calc(100% + 10px);
  width: 340px;
  max-width: calc(100vw - 48px);
  padding: 18px;
  box-sizing: border-box;
  border: 1px solid #dce5ef;
  border-radius: 12px;
  box-shadow: 0 10px 35px rgba(23, 43, 70, 0.13);
  background: #fff;
}

.filter-heading h2 {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
}

.filter-heading p {
  margin: 4px 0 14px;
  color: #7d8a9d;
  font-size: 11px;
}

.filter-label {
  display: block;
  margin: 12px 0 6px;
  color: #53647a;
  font-size: 11px;
  font-weight: 500;
}

.filter-dropdown mat-form-field {
  width: 100%;
  font-size: 11px;
  --mat-form-field-container-height: 36px;
  --mat-form-field-container-vertical-padding: 8px;
  --mdc-outlined-text-field-outline-color: #dce5ef;
  --mdc-outlined-text-field-focus-outline-color: var(--primary-color);
}

.filter-search {
  position: relative;
}

.filter-search > span {
  position: absolute;
  z-index: 1;
  inset-inline-start: 10px;
  top: 9px;
  color: #8a98ab;
  font-size: 17px;
}

.filter-search input {
  width: 100%;
  height: 36px;
  box-sizing: border-box;
  border: 1px solid #dce5ef;
  border-radius: 7px;
  padding: 0 10px 0 33px;
  color: #253750;
  font: inherit;
  font-size: 11px;
}

.filter-search input:focus {
  outline: none;
  border-color: var(--primary-color);
}

.date-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.date-fields > div,
.date-fields mat-form-field {
  min-width: 0;
}

.date-fields mat-form-field {
  width: 100%;
  max-width: 100%;
}

.filter-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid #edf1f6;
}

.filter-dropdown {
  z-index: 20;
}

.skeleton-row td {
  height: 43px;
}

.table-skeleton {
  display: block;
  min-width: 56px;
  height: 12px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f1f4f8 25%, #f8fafc 40%, #f1f4f8 65%);
  background-size: 400% 100%;
  animation: transaction-skeleton-loading 1.35s ease infinite;
}

@keyframes transaction-skeleton-loading {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/my-transaction-list/my-transaction-list.component.overrides.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,4DAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,gCAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,8CAAA;EACA,gBAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;EACA,uCAAA;EACA,gDAAA;EACA,gDAAA;EACA,mEAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,wBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,kCAAA;AACF;;AAEA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AACF;;AAEA;;EAEE,YAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,yEAAA;EACA,0BAAA;EACA,2DAAA;AACF;;AAEA;EACE;IACE,2BAAA;EACF;EAEA;IACE,wBAAA;EAAF;AACF","sourcesContent":[".truncate {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  cursor: default;\n}\n\n.product-cell {\n  max-width: 135px;\n}\n\n.name-cell {\n  max-width: 90px;\n}\n\n.email-cell {\n  max-width: 150px;\n}\n\n.address-cell {\n  max-width: 155px;\n}\n\n.export-button mat-spinner {\n  --mdc-circular-progress-active-indicator-color: currentColor;\n}\n\n.filter-wrapper {\n  position: relative;\n}\n\n.filter-dot {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: var(--primary-color);\n}\n\n.filter-dropdown {\n  position: absolute;\n  z-index: 5;\n  inset-inline-end: 0;\n  top: calc(100% + 10px);\n  width: 340px;\n  max-width: calc(100vw - 48px);\n  padding: 18px;\n  box-sizing: border-box;\n  border: 1px solid #dce5ef;\n  border-radius: 12px;\n  box-shadow: 0 10px 35px rgba(23, 43, 70, .13);\n  background: #fff;\n}\n\n.filter-heading h2 {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 20px;\n}\n\n.filter-heading p {\n  margin: 4px 0 14px;\n  color: #7d8a9d;\n  font-size: 11px;\n}\n\n.filter-label {\n  display: block;\n  margin: 12px 0 6px;\n  color: #53647a;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.filter-dropdown mat-form-field {\n  width: 100%;\n  font-size: 11px;\n  --mat-form-field-container-height: 36px;\n  --mat-form-field-container-vertical-padding: 8px;\n  --mdc-outlined-text-field-outline-color: #dce5ef;\n  --mdc-outlined-text-field-focus-outline-color: var(--primary-color);\n}\n\n.filter-search {\n  position: relative;\n}\n\n.filter-search>span {\n  position: absolute;\n  z-index: 1;\n  inset-inline-start: 10px;\n  top: 9px;\n  color: #8a98ab;\n  font-size: 17px;\n}\n\n.filter-search input {\n  width: 100%;\n  height: 36px;\n  box-sizing: border-box;\n  border: 1px solid #dce5ef;\n  border-radius: 7px;\n  padding: 0 10px 0 33px;\n  color: #253750;\n  font: inherit;\n  font-size: 11px;\n}\n\n.filter-search input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n}\n\n.date-fields {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.date-fields>div,\n.date-fields mat-form-field {\n  min-width: 0;\n}\n\n.date-fields mat-form-field {\n  width: 100%;\n  max-width: 100%;\n}\n\n.filter-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 18px;\n  padding-top: 14px;\n  border-top: 1px solid #edf1f6;\n}\n\n.filter-dropdown {\n  z-index: 20;\n}\n\n.skeleton-row td {\n  height: 43px;\n}\n\n.table-skeleton {\n  display: block;\n  min-width: 56px;\n  height: 12px;\n  border-radius: 4px;\n  background: linear-gradient(90deg, #f1f4f8 25%, #f8fafc 40%, #f1f4f8 65%);\n  background-size: 400% 100%;\n  animation: transaction-skeleton-loading 1.35s ease infinite;\n}\n\n@keyframes transaction-skeleton-loading {\n  0% {\n    background-position: 100% 0;\n  }\n\n  100% {\n    background-position: 0 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
